import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosolapurcabservice() {



    const cardData = {

keyword: "Pune to Solapur Cab Service",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Pune to Solapur Cab Service for families, business travelers, students, and pilgrims. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a safe and smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for business, education, temple visits, or family trips, Rising Cab Service ensures a hassle-free travel experience to Solapur.",

topPlaces: [
    {
        title: "Siddheshwar Temple",
        description:
            "Siddheshwar Temple is one of the most famous temples in Solapur dedicated to Lord Shiva and Lord Vishnu. It is located on a beautiful lake island and attracts thousands of devotees."
    },
    {
        title: "Great Indian Bustard Sanctuary (Nannaj)",
        description:
            "Nannaj Sanctuary near Solapur is known for the critically endangered Great Indian Bustard and other wildlife species, making it an important eco-tourism destination."
    },
    {
        title: "Bhuikot Fort",
        description:
            "Bhuikot Fort is a historic fort in Solapur reflecting medieval architecture and Maratha history. It is a popular heritage site within the city."
    },
    {
        title: "Hipparga Lake",
        description:
            "Hipparga Lake is a peaceful water body near Solapur ideal for relaxation, bird watching, and evening outings."
    },
    {
        title: "Solapur Science Centre",
        description:
            "Solapur Science Centre is an educational attraction featuring science exhibits, interactive displays, and learning activities for students and families."
    },
    {
        title: "Siddheshwar Forest",
        description:
            "Siddheshwar Forest area around the temple provides a calm natural environment with greenery and walking spaces for visitors."
    },
    {
        title: "Akkalkot Swami Samarth Temple",
        description:
            "Akkalkot Swami Samarth Temple is a highly revered spiritual destination near Solapur dedicated to Swami Samarth, attracting devotees from across Maharashtra."
    },
    {
        title: "Pandharpur (Nearby Pilgrimage)",
        description:
            "Pandharpur is a major pilgrimage destination near Solapur dedicated to Lord Vitthal. It is one of the most visited spiritual towns in Maharashtra."
    },
    {
        title: "Solapur Textile Market",
        description:
            "Solapur is famous for its textile industry, especially towels and bedsheets. The textile market is a key commercial attraction in the city."
    },
    {
        title: "Hotgi Dam",
        description:
            "Hotgi Dam near Solapur is a scenic spot surrounded by natural landscapes, popular for picnics and peaceful outings."
    }
],



services: [
    {
        name: "Pune to Solapur Cab",
        description:
            "Rising Cab Service offers Pune to Solapur Cab for safe, comfortable, and reliable intercity travel. This service is ideal for business trips, family visits, educational travel, industrial visits, and weekend journeys. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with professional and experienced drivers. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With transparent pricing, 24x7 availability, and smooth highway driving experience, we ensure a stress-free journey between Pune and Solapur."
    },
    {
        name: "Pune to Solapur Taxi",
        description:
            "Book Pune to Solapur Taxi with Rising Cab Service for affordable and safe long-distance travel. Our taxis are suitable for solo travelers, families, and corporate passengers looking for comfortable highway journeys with professional chauffeurs."
    },
    {
        name: "Cab from Pune to Solapur",
        description:
            "Rising Cab Service provides Cab from Pune to Solapur with flexible pickup options, clean AC vehicles, and reliable drivers ensuring timely and smooth intercity travel."
    },
    {
        name: "Taxi from Pune to Solapur",
        description:
            "Our Taxi from Pune to Solapur service ensures safe and convenient travel with experienced drivers, comfortable seating, and budget-friendly pricing for all passengers."
    },
    {
        name: "Pune to Solapur Cab Service",
        description:
            "Rising Cab Service offers Pune to Solapur Cab Service with easy booking, professional chauffeurs, and well-maintained vehicles suitable for all types of travel needs."
    },
    {
        name: "Pune to Solapur Taxi Fare",
        description:
            "Get transparent and affordable Pune to Solapur Taxi Fare with no hidden charges. We offer budget-friendly pricing and flexible ride options for every traveler."
    },
    {
        name: "Pune to Solapur One Way Cab",
        description:
            "Book Pune to Solapur One Way Cab for economical single-trip travel with comfortable vehicles and experienced highway drivers."
    },
    {
        name: "Pune to Solapur Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Solapur Round Trip Taxi with flexible return timing, waiting options, and customized travel plans for families and corporate travelers."
    },
    {
        name: "Pune to Solapur Cab Booking",
        description:
            "Our Pune to Solapur Cab Booking service offers instant confirmation, multiple vehicle choices, and 24x7 support for seamless travel planning."
    },
    {
        name: "Cheap Pune to Solapur Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Solapur Cab with economical fares while maintaining safety, comfort, and reliable service quality."
    },
    {
        name: "Best Pune to Solapur Taxi",
        description:
            "Choose the Best Pune to Solapur Taxi with Rising Cab Service for premium comfort, punctual service, and professional drivers ensuring smooth travel."
    },
    {
        name: "Sedan Pune to Solapur Cab",
        description:
            "Our Sedan Pune to Solapur Cab service is ideal for individuals and small families seeking affordable and comfortable intercity travel."
    },
    {
        name: "SUV Pune to Solapur Taxi",
        description:
            "Book SUV Pune to Solapur Taxi for spacious seating, extra luggage space, and comfortable group travel on long highway routes."
    },
    {
        name: "Innova Pune to Solapur Cab",
        description:
            "Rising Cab Service offers Innova Pune to Solapur Cab for family and group travel with premium comfort and smooth highway experience."
    },
    {
        name: "Intercity Cab Pune Solapur",
        description:
            "Our Intercity Cab Pune Solapur service ensures safe, reliable, and comfortable long-distance travel with experienced drivers and AC vehicles."
    },
    {
        name: "Pune to Solapur Innova Crysta Cab",
        description:
            "Book Pune to Solapur Innova Crysta Cab for premium travel experience with spacious seating, luxury comfort, and professional chauffeurs."
    },
    {
        name: "Pune to Pandharpur Cab",
        description:
            "Rising Cab Service offers Pune to Pandharpur Cab for safe pilgrimage travel with comfortable vehicles and experienced drivers for temple visits."
    },
    {
        name: "Pune to Pandharpur Taxi Service",
        description:
            "Our Pune to Pandharpur Taxi Service ensures smooth and reliable travel for devotees visiting Vitthal Rukmini temple with flexible booking options."
    },
    {
        name: "Pandharpur Darshan Cab from Pune",
        description:
            "Book Pandharpur Darshan Cab from Pune for comfortable pilgrimage travel with door-to-door pickup and flexible schedules."
    },
    {
        name: "Pune to Pandharpur Cab Booking",
        description:
            "Rising Cab Service provides Pune to Pandharpur Cab Booking with instant confirmation and affordable travel packages."
    },
    {
        name: "Pune to Pandharpur Tempo Traveller",
        description:
            "Our Pune to Pandharpur Tempo Traveller service is ideal for group pilgrimages with spacious seating and comfortable long-distance travel."
    },
    {
        name: "Pune to Pandharpur Tour Package Cab",
        description:
            "Book Pune to Pandharpur Tour Package Cab for complete pilgrimage travel with flexible itineraries and comfortable vehicles."
    },
    {
        name: "Pune to Tuljapur Cab Booking",
        description:
            "Rising Cab Service offers Pune to Tuljapur Cab Booking for safe and reliable temple travel with professional chauffeurs."
    },
    {
        name: "Pune to Tuljapur Cab Service",
        description:
            "Our Pune to Tuljapur Cab Service ensures comfortable pilgrimage travel with AC vehicles and experienced drivers."
    },
    {
        name: "Tuljapur Darshan Cab from Pune",
        description:
            "Book Tuljapur Darshan Cab from Pune for smooth temple visits with flexible timing and comfortable travel options."
    },
    {
        name: "Pune to Tuljapur Taxi Service",
        description:
            "Rising Cab Service provides Pune to Tuljapur Taxi Service for safe and affordable religious travel with door-to-door pickup."
    },
    {
        name: "One Way Pune to Tuljapur Cab",
        description:
            "Our One Way Pune to Tuljapur Cab service offers economical single-trip travel with reliable drivers and comfortable vehicles."
    },
    {
        name: "Round Trip Tuljapur Taxi Pune",
        description:
            "Book Round Trip Tuljapur Taxi Pune for flexible return journeys with waiting options and customized travel plans."
    },
    {
        name: "Pune to Tuljapur Innova Crysta",
        description:
            "Rising Cab Service offers Pune to Tuljapur Innova Crysta for premium comfort and spacious seating for family pilgrimage trips."
    },
    {
        name: "Pune to Tuljapur Tempo Traveller",
        description:
            "Our Pune to Tuljapur Tempo Traveller service is perfect for group travel with comfortable seating and safe long-distance journey."
    },
    {
        name: "Pune to Tuljapur Family Tour Cab",
        description:
            "Book Pune to Tuljapur Family Tour Cab for safe, comfortable, and affordable family pilgrimage travel experience."
    }
],
tableData: [
    ["Pune to Solapur Cab", "Pune to Solapur Taxi"],
    ["Cab from Pune to Solapur", "Taxi from Pune to Solapur"],
    ["Pune to Solapur One Way Cab", "Pune to Solapur Round Trip Taxi"],
    ["Pune to Solapur Cab Service", "Pune to Solapur Taxi Fare"],
    ["Cheap Pune to Solapur Cab", "Best Pune to Solapur Taxi"],
    ["Sedan Pune to Solapur Cab", "SUV Pune to Solapur Taxi"],
    ["Innova Pune to Solapur Cab", "Intercity Cab Pune Solapur"],
    ["Pune to Solapur Innova Crysta Cab", "Pune to Pandharpur Cab"],
    ["Pune to Pandharpur Taxi Service", "Pandharpur Darshan Cab from Pune"],
    ["Pune to Tuljapur Cab Service", "Tuljapur Darshan Cab from Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Solapur Cab Transportation",
        WhyChoosedescription: "Rising Cab Service offers dependable Pune to Solapur cab services for families, business travelers, pilgrims, students, and tourists seeking a comfortable road journey."
    },
    {
        WhyChooseheading: "Suitable for Business and Personal Travel",
        WhyChoosedescription: "Whether visiting Solapur for official meetings, family functions, educational purposes, or personal work, we provide convenient travel solutions."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Routes",
        WhyChoosedescription: "Travelers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on comfort and passenger requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Options",
        WhyChoosedescription: "Customers have the flexibility to select one-way transfers, same-day return journeys, weekend travel plans, or multi-day cab packages."
    },
    {
        WhyChooseheading: "Popular for Religious and Pilgrimage Tours",
        WhyChoosedescription: "Many devotees book Pune to Solapur cabs while visiting Pandharpur, Akkalkot, Tuljapur, Gangapur, and other nearby spiritual destinations."
    },
    {
        WhyChooseheading: "Pickup Service from All Pune Locations",
        WhyChoosedescription: "Doorstep pickup is available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our drivers are familiar with the Pune-Solapur route and ensure a safe, smooth, and efficient travel experience."
    },
    {
        WhyChooseheading: "Customized Travel Plans Available",
        WhyChoosedescription: "Passengers can add sightseeing locations, temple visits, business stops, and nearby destinations according to their travel preferences."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Solapur from Pune?",
        answer: "Solapur is known for its business centers, textile industry, educational institutions, religious destinations, and connectivity to nearby pilgrimage locations."
    },
    {
        question: "Can I book a one-way cab from Pune to Solapur?",
        answer: "Yes, one-way cab services are available along with return-trip and customized travel packages."
    },
    {
        question: "Which nearby pilgrimage destinations can be covered from Solapur?",
        answer: "Popular religious destinations include Pandharpur, Akkalkot, Tuljapur, Gangapur, and other important temples in the region."
    },
    {
        question: "What vehicle options are available for Pune to Solapur travel?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles."
    },
    {
        question: "Is same-day return travel possible for Solapur trips?",
        answer: "Yes, same-day return packages can be arranged depending on travel requirements and itinerary plans."
    },
    {
        question: "Can corporate travelers use this service for official visits?",
        answer: "Yes, business professionals regularly book Pune to Solapur cabs for meetings, industrial visits, and corporate travel."
    },
    {
        question: "Do families book larger vehicles for group travel?",
        answer: "Yes, Tempo Travellers and spacious vehicles are available for family trips, functions, and group journeys."
    },
    {
        question: "Can multiple destinations be included during the journey?",
        answer: "Yes, customized itineraries can include religious places, tourist attractions, and personal travel stops."
    },
    {
        question: "Are airport and railway station pickups available in Pune?",
        answer: "Yes, passengers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I reserve a Pune to Solapur Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Dhananjay Kulkarni",
        feedback:
            "My business trip to Solapur was managed very professionally. The vehicle was comfortable, the driver was experienced, and the journey was completed without any inconvenience.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaibhavi Pawar",
        feedback:
            "We planned a family visit covering Solapur and nearby temples. The travel arrangements were excellent, and the entire trip remained smooth and enjoyable.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Solapur Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-solapur-cab.jpg",
"description": "Book Pune to Solapur Cab Service with Rising Cab Service for safe, comfortable, and affordable intercity travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova options for family and business trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-solapur-cab-service"
}
};






    return (
        <div>
<Helmet>
  <title>Pune to Solapur Cab Service | One Way & Round Trip Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Solapur Cab Service for safe and affordable intercity travel. Get reliable one-way and round-trip taxi service with sedan, SUV, and Innova cab options."
/>

<meta
 name="keywords"
 content="pune to solapur cab, pune to solapur taxi, cab from pune to solapur, taxi from pune to solapur, pune to solapur cab service, pune to solapur taxi fare, pune to solapur one way cab, pune to solapur round trip taxi, pune to solapur cab booking, cheap pune to solapur cab, best pune to solapur taxi, sedan pune to solapur cab, suv pune to solapur taxi, innova pune to solapur cab, intercity cab pune solapur, Pune to Solapur Cab Service, Pune to Solapur Taxi Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosolapurcabservice;